import { useEffect, useState } from 'react';
import { Platforms } from '../../model/platform/Platforms';
import { BookingService } from '../../app/brand/campaign/book/service';
import { ErrorToast } from '../../utils/toasters';

interface ISocialPlatformParams {
    hasApi?: boolean;
    isEnabled: boolean;
}

export const useSocialPlatform = (filterParams: ISocialPlatformParams) => {
    const [platforms, setSocialPlatforms] = useState<Platforms[]>([]);
    const [selectedDefaultPlatform, setSelectedPlatform] = useState<Platforms>(platforms[0]);

    useEffect(() => {
        BookingService.getPlatform(filterParams)
            .then(response => {
                setSocialPlatforms(response.data);
                setSelectedPlatform(response.data[0]);
            })
            .catch(err => ErrorToast(err));
    }, []);

    return {
        platforms,
        selectedDefaultPlatform,
        setSelectedPlatform,
    };
};
